import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorSuitability(
    $liquidityNeeds: LiquidityNeeds!
    $riskTolerance: RiskTolerance!
    $yearsOfExperience: YearsOfExperience!
    $investmentFrequency: InvestmentFrequency!
    $investmentAllocation: Float!
    $investmentDecisionConsultProfessional: Boolean
    $investmentDecisionConsultSelf: Boolean
    $investmentDecisionConsultFamilyFriends: Boolean
    $investmentSelectionsConfirmed: Boolean
  ) {
    updateInvestorSuitability(
      input: {
        liquidityNeeds: $liquidityNeeds
        riskTolerance: $riskTolerance
        yearsOfExperience: $yearsOfExperience
        investmentFrequency: $investmentFrequency
        investmentAllocation: $investmentAllocation
        investmentDecisionConsultProfessional: $investmentDecisionConsultProfessional
        investmentDecisionConsultSelf: $investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends: $investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed: $investmentSelectionsConfirmed
      }
    ) {
      _id
      canViewOffers
      accreditationStatus
      suitability {
        _id
        liquidityNeeds
        riskTolerance
        yearsOfExperience
        investmentFrequency
        investmentAllocation
        investmentDecisionConsultProfessional
        investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorSuitability.js